import { css, styled, Theme } from '@mui/material';

import { ComposeTypeParam } from '../../../models/pageParams';
import devices from '../../../styles/devices';
import HeaderSegmentedButtons from '../SegmentedButtons';

type HeaderContentProps = {
  'data-compose-type': ComposeTypeParam | null;
};

/**
 * Get compose header styles
 *
 * @param props Props passed to the styled element
 *
 * @returns     Styles for the compose header
 */
const getComposeHeaderStyles = (
  props: HeaderContentProps & { theme: Theme },
) => {
  const { 'data-compose-type': composeType, theme } = props;

  if (composeType === null) {
    return null;
  }

  const isPost = composeType === 'post';
  const borderColor = theme.palette[isPost ? 'secondary' : 'tertiary'].main;

  return css`
    background-color: var(--color-background-compose);
    border-bottom: none;
    border-top: var(--preference-compose-header-bottom-border-width) solid
      ${borderColor};

    h1 {
      color: var(--color-primary);
      font-size: var(--font-sm);
      font-weight: var(--font-weight-heading);
    }
  `;
};

/**
 * Calculated based on button width
 * (translate button + help button)
 */
const sideWidthMin = '70px';

export const HeaderContent = styled('div')<HeaderContentProps>`
  align-items: center;
  background-color: var(--color-background);
  border-bottom: var(--border-dark);
  display: grid;
  gap: var(--spacing-tiny);
  grid-template-columns: ${sideWidthMin} 1fr minmax(${sideWidthMin}, auto);
  padding: var(--spacing-small);
  ${getComposeHeaderStyles}

  @media ${devices.tabletS} {
    display: none;
  }
`;

const sideContent = css`
  align-items: center;
  display: flex;
`;

/**
 * Container for the Info icon
 */
export const RightElementContainer = styled('div')`
  justify-content: flex-end;
  ${sideContent}
`;

/**
 * Container for the Burger menu
 */
export const LeftElementContainer = styled('div')`
  justify-content: flex-start;
  ${sideContent}
`;

export const SubheaderWrapper = styled('div')({
  '&:empty': {
    display: 'none',
  },
  display: 'grid',
  gap: 'var(--spacing-medium)',
  gridTemplateColumns: '1fr',
  gridTemplateRows: 'auto auto auto',
  justifyContent: 'start',
  padding: '0 var(--spacing-tiny)',
});

export const SegmentedButtons = styled(HeaderSegmentedButtons)`
  grid-row: 2;
`;
